import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "view-tiles.icon",
  "use": "view-tiles.icon-usage",
  "viewBox": "0 0 17.697 17.697",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.697 17.697\" id=\"view-tiles.icon\"><defs><style>#view-tiles.icon .cls-1{fill:#b4b4b4}</style></defs><path id=\"view-tiles.icon_Statistics.BG\" class=\"cls-1\" transform=\"rotate(180 8.848 4.056)\" d=\"M0 0H17.697V8.111H0z\" /><path id=\"view-tiles.icon_Statistics.BG-2\" data-name=\"Statistics.BG\" class=\"cls-1\" transform=\"rotate(180 8.848 8.848)\" d=\"M0 0H17.697V8.111H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/view-tiles.icon.svg
// module id = VHJp
// module chunks = 13